module.exports = __webpack_public_path__ + "static/media/valor3_2.055855b8.png";